const ROUNDED_CLASS_NAMES = {
  none: "rounded-none",
  sm: "rounded-sm",
  md: "rounded-md",
  lg: "rounded-lg",
  xl: "rounded-xl",
  full: "rounded-full",
};

export function SkeletonBone({
  className = "",
  rounded = "md",
}) {
  return (
    <div
      className={[
        "workspace-skeleton-pulse bg-[#e5e7eb]",
        ROUNDED_CLASS_NAMES[rounded] ?? ROUNDED_CLASS_NAMES.md,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      aria-hidden
    />
  );
}
